"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var Styled = __importStar(require("./SpeedDialStyles"));
var button_1 = __importDefault(require("../button"));
var react_feather_1 = require("react-feather");
var useOutsideClick_1 = __importDefault(require("../../utils/useOutsideClick"));
var styled_components_1 = require("styled-components");
var body_1 = __importDefault(require("../body"));
var SpeedDial = function (_a) {
    var actions = _a.actions, disabled = _a.disabled, theme = _a.theme;
    var _b = React.useState(false), open = _b[0], setOpen = _b[1];
    var speedDialRef = React.useRef(null);
    (0, useOutsideClick_1.default)(speedDialRef, function (event) { return setOpen(false); });
    return (React.createElement(Styled.SpeedDial, { ref: speedDialRef, onMouseLeave: function () { return setOpen(false); } },
        React.createElement(Styled.FabContainter, { onMouseEnter: function () { return !disabled && setOpen(true); }, open: open },
            React.createElement(button_1.default, { disabled: disabled, variant: "primary", onClick: function () { return setOpen(!open); } },
                React.createElement(react_feather_1.Plus, null))),
        React.createElement(Styled.ActionItemsMap, { visible: open }, actions.map(function (item, idx) {
            if (!(item === null || item === void 0 ? void 0 : item.onClick) && (item === null || item === void 0 ? void 0 : item.label)) {
                return (React.createElement(Styled.ActionNoteWrapper, { key: item === null || item === void 0 ? void 0 : item.label, visible: open, idx: idx, total: actions.length },
                    React.createElement(Styled.ActionItemButtonWrapper, { isDarkTheme: (theme === null || theme === void 0 ? void 0 : theme.themeName) === "dark", padding: "1.6rem" },
                        React.createElement(body_1.default, { withoutMargins: true }, item.label))));
            }
            if (item !== undefined) {
                return (React.createElement(Styled.ActionItemWrapper, { key: item.label, visible: open, idx: idx, total: actions.length },
                    React.createElement(Styled.ActionItemButtonWrapper, { isDarkTheme: (theme === null || theme === void 0 ? void 0 : theme.themeName) === "dark" },
                        React.createElement(button_1.default, { variant: "subtle", size: "small", onClick: item.onClick }, item.label))));
            }
            else {
                return null;
            }
        }))));
};
exports.default = (0, styled_components_1.withTheme)(SpeedDial);
